var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection2Icon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.773 16.9575V20.1655M17.273 10.9995H20.94M2.60498 10.9995H5.81298M11.773 5.04053V1.83253M11.772 20.1655C12.9838 20.1782 14.1861 19.9504 15.3093 19.4955C16.4326 19.0405 17.4544 18.3673 18.3158 17.5148C19.1772 16.6624 19.861 15.6476 20.3277 14.5292C20.7944 13.4108 21.0347 12.2109 21.0347 10.999C21.0347 9.78715 20.7944 8.58729 20.3277 7.46887C19.861 6.35045 19.1772 5.33567 18.3158 4.48322C17.4544 3.63078 16.4326 2.95759 15.3093 2.50261C14.1861 2.04762 12.9838 1.81987 11.772 1.83253C9.35746 1.85775 7.05039 2.83461 5.35191 4.55092C3.65343 6.26723 2.70072 8.58438 2.70072 10.999C2.70072 13.4137 3.65343 15.7308 5.35191 17.4471C7.05039 19.1635 9.35746 20.1403 11.772 20.1655Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.60498)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Icon2);
export default __webpack_public_path__ + "static/media/section2_icon2.4f37f7533fe8384deeae0a397ba37251.svg";
export { ForwardRef as ReactComponent };